"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var mapDispatchers = function (dispatch) { return ({
    browseHistory: function (browse) { return function () {
        return dispatch(WizardActions.step3Browse(browse));
    }; },
    removeFile: function (uuids) { return function () { return (dispatch(WizardActions.step3RemoveFile(uuids)),
        dispatch(WizardActions.step3UnselectFiles(uuids))); }; },
    toggleProceedWithoutInvalidFiles: function () {
        return dispatch(WizardActions.proceedWithoutInvalidFiles());
    },
    prevalidateFiles: function (folder, files, type) { return dispatch(WizardActions.prevalidateFilesRequest(folder.id, files, type)); },
    preValidateImportedFiles: function (folder, files, type) {
        return dispatch(WizardActions.prevalidateImportedFilesRequest(folder.id, files, type));
    },
    restoreFiles: function () { return dispatch(WizardActions.step3RestoreFile()); },
    fetchOrderFiles: function (id, mode) {
        return dispatch(WizardActions.fetchOrderFilesRequest(id, mode));
    },
    selectFile: function (uuids) {
        return dispatch(WizardActions.step3SelectFiles(uuids));
    },
    changeColor: function (file, color) {
        return dispatch(WizardActions.step3ChangeColor(file, color));
    },
    unselectFile: function (uuids) {
        return dispatch(WizardActions.step3UnselectFiles(uuids));
    }
}); };
exports.mapDispatchers = mapDispatchers;
